var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.999,
    height: 14.5,
    viewBox: "0 0 13.999 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search_5_",
    "data-name": "search (5)",
    d: "M14.77,13.207,11.319,9.618a5.852,5.852,0,1,0-4.481,2.091,5.792,5.792,0,0,0,3.354-1.059l3.477,3.616a.764.764,0,1,0,1.1-1.059ZM6.838,1.527A4.327,4.327,0,1,1,2.511,5.854,4.332,4.332,0,0,1,6.838,1.527Z",
    transform: "translate(-0.984)",
    fill: "#b7b7b7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch5);
export default __webpack_public_path__ + "static/media/search (5).1173af639c0a4d3f8042908974dec14c.svg";
export { ForwardRef as ReactComponent };